var _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgSmartphone = function SvgSmartphone(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 13.333c0-5.028 0-7.542 1.562-9.104C8.457 2.666 10.971 2.666 16 2.666c5.028 0 7.542 0 9.104 1.563 1.562 1.562 1.562 4.076 1.562 9.104v5.333c0 5.029 0 7.543-1.562 9.105-1.562 1.562-4.076 1.562-9.104 1.562-5.029 0-7.543 0-9.105-1.562-1.562-1.562-1.562-4.076-1.562-9.105v-5.333Z",
    stroke: "#0065E5",
    strokeWidth: 2.107
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.667h-8",
    stroke: "#0065E5",
    strokeWidth: 2.107,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 25.333,
    r: 1.333,
    stroke: "#0065E5",
    strokeWidth: 1.405
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.333 22.667h21.333M5.333 9.333h21.333",
    stroke: "#0065E5",
    strokeWidth: 1.405
  })));
};

export default SvgSmartphone;